import React from 'react';
import img from '../../../Images/profile1.png'

const About = () => {
    return (
        <section className='py-5'>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-5">
                        <img className='img-fluid' src={img} alt="" />
                    </div>
                    <div className="col-md-7">
                        <div className='shadow-lg border-1 rounded-3 p-5'>
                            <h3 className='text-success'>Muraduzzaman Bipu</h3>
                            <p>Hello!Myself Muraduzzaman Bipu.My goal is to demonstrate my abilities as a capable web developer as soon as possible.I'm now working on a difficult level of study. I trying to always on course track. And I'm trying hard and soul for learning for the rest of my life.I want to work on large-scale projects all across the world and start my own startup.HTML, CSS, Bootstrap, Tailwind CSS, Javascript, and ReactJS are now all almost familiar to me.I'll always give my best to achieve my goal, inshaAllah. </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;